<template>
  <el-select :disabled="disabled" filterable :clearable='clearable' @change="handleChange" :value="data.value" placeholder="请选择"
             @clear="handleChange">
    <el-option :label="item.name" :value="item.value" v-for="(item,index) in deviceType" :key="index"></el-option>
  </el-select>
</template>

<script>
    import {getCascade} from '@/services/product'
    // import { findTypeList } from "@/services/deviceOrder";

    export default {
        name: 'Operator',
        props: {
            value: {},
            brandId:{
                type: String,
                default: ''
            },
            disabled: {
                type: Boolean,
                default: false
            },
            clearable:{
                type: Boolean,
                default: true
            }
        },

        data() {
            return {data: {}, deviceType: []}
        },
        watch: {
            value:{
                immediate:true,
                handler(value){
                    if (value) {
                        console.log(value,"sdsds333333333")
                            this.data = value;
                        } else {
                            this.data = {};
                        }

                }
            },
            brandId:{
                immediate:true,
                handler(value){
                    this.loadData(value);
                }
            },
        },
        mounted() {
            // this.loadData();
        },
        methods: {
           
            handleChange(value) {
                
                let find = this.deviceType.find((item, i) => {
                    return item.value == value
                })
                if (!find) {
                    find = {};
                }
               
                if (find==undefined) {
                    find = "";
                }
                this.$emit("input", {...find});
                this.$emit("change", {...find});
                this.data = {...find};
            },
            async loadData(brandId) {
               
                const response = await getCascade( { brandId });
              
                if (response&&response.code==0) {
                    this.deviceType = response.data.brand.map((item, i) => {
                        return {name: item.brandName, value: item.brandId}
                    })
                }
              
            }

        }

    }
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/operation/deviceType.vue